// @flow

import type { FlightsRoundTripDatesRecord, FlightsOneWayDatesRecord } from './records';

class FlightsAccumulator {
  today: Date = new Date();
  oneWayDate: null | Date = null;
  departureDate: null | Date = null;
  returnDate: null | Date = null;

  RTD(record: FlightsRoundTripDatesRecord) {
    this.validateAndRecordRoundTripDatesDate(record.departureDate, record.returnDate);
  }
  OWD(record: FlightsOneWayDatesRecord) {
    this.validateAndRecordOneWayDate(record.date);
  }

  validateAndRecordOneWayDate(date: null | Date) {
    if (date === null || date < this.today) {
      return;
    }
    this.oneWayDate = date;
  }

  validateAndRecordRoundTripDatesDate(departureDate: null | Date, returnDate: null | Date) {
    if (
      departureDate === null ||
      departureDate < this.today ||
      returnDate === null ||
      returnDate < this.today ||
      departureDate > returnDate
    ) {
      return;
    }
    this.departureDate = departureDate;
    this.returnDate = returnDate;
  }
}

export default FlightsAccumulator;
